import { MemoizedNoteNode } from '../MemoizedNodes';

export default function NoteNodeItem({
  task,
  commonProps,
  handlers,
}) {
  return (
    <MemoizedNoteNode
      {...commonProps}
      onDelete={handlers.onDelete}
      onCopy={handlers.onCopy}
      onDuplicate={handlers.onDuplicate}
    />
  );
}
